<div class="panel panel-primary">
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="panel-heading">
        Order Monitoring
        <div class="pull-right">
            <button nz-button class="pf-form-action" (click)="Update()">
                <span class="fa-solid fa-floppy-disk"></span>Save
            </button>
        </div>
    </div>
    <div class="panel-body">
        @if (PO.ContactInformation) {
            <div class="panel panel-default">
                <div class="panel-heading">Shipping Information</div>
                <div class="panel-body">
                    <div role="form" class="form-horizontal">
                        <div class="form-group">
                            <div class="col-md-2 control-label">Ship To Address 1</div>
                            <div class="col-md-4">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToAddressLine1"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To Address 2</div>
                            <div class="col-md-4">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToAddressLine2"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2 control-label">Ship To City</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToCity"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To State</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToState"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To ZIP</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToZip"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2 control-label">Ship To Email</div>
                            <div class="col-md-2">
                                <input
                                    type="email"
                                    [(ngModel)]="PO.ContactInformation.ShipToEmail"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To Phone</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToPhone"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To Fax</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToFax"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="panel panel-default">
            <div class="panel-heading">Tracking Notes</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-12">
                            <textarea
                                class="form-control"
                                [(ngModel)]="PO.TrackingNotes"
                                [ngModelOptions]="{standalone: true}"
                                style="height: 100px; width: 100%"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading">
                Tracking Numbers
                <div class="pull-right">
                    <button
                        class="btn btn-default"
                        style="padding: 2px 8px; margin-top: -2px"
                        (click)="ShowCreateTrack(addTrackNumber)">
                        <span class="fa-solid fa-plus"></span>
                    </button>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Tracking #</th>
                            <th>Shipped Via</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of PO.Trackings; track item) {
                            <tr>
                                <td>
                                    {{ item.TrackingNumber }}
                                </td>
                                <td>
                                    {{ item.ShippedVia }}
                                </td>
                                <td>
                                    <button class="btn btn-danger" style="padding: 2px 8px" (click)="RemoveItem(item)">
                                        <span class="fa-solid fa-trash"></span>
                                    </button>
                                </td>
                            </tr>
                        }
                        @if (!PO.Trackings || PO.Trackings.length < 1) {
                            <tr>
                                <td colspan="3">No items.</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <ng-template #addTrackNumber>
        <div class="modal-header">Add Tracking Number</div>
        <form #trackForm="ngForm" (ngSubmit)="AddItem(trackForm, NewRequest)">
            <div class="modal-body">
                <div class="form-group">
                    <div class="col-md-2 control-label">Tracking #</div>
                    <input
                        type="text"
                        name="trackNum"
                        [(ngModel)]="NewRequest.TrackingNumber"
                        class="form-control"
                        placeholder="Enter tracking #"
                        required />
                </div>
                <div class="form-group">
                    <div class="col-md-2 control-label">Shipped Via</div>
                    <input
                        type="text"
                        name="shipVia"
                        [(ngModel)]="NewRequest.ShippedVia"
                        class="form-control"
                        placeholder="Enter shipped via"
                        required />
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-default">Create</button>
            </div>
        </form>
    </ng-template>
</div>
